import React from 'react';
import { useTranslation } from 'react-i18next';
import { LoadingSpinner } from '../components/LoadingSpinner';
import NotificationCard from '../components/notifications/NotificationCard';
import useNotifications from '../hooks/useNotifications';

const Notifications: React.FC = () => {
  const { notifications, loading, hasMore, error, fetchMore } = useNotifications({
    initialCount: 20,
  });
  const { t } = useTranslation('notifications');

  return (
    <div className="flex flex-col mb-8 md:min-h-[calc(100vh-4rem)] md:px-5 lg:px-32">
      <div className="w-full pt-4 pb-5 flex flex-col md:w-2/3 md:px-1 md:pr-8 md:pb-8">
        <h1 className="text-5xl text-secondary font-bold hyphens-auto">{t('title')}</h1>
      </div>

      <div className="flex flex-col gap-6">
        {loading && notifications.length === 0 && (
          <div className="flex justify-center items-center h-10">
            <LoadingSpinner />
          </div>
        )}

        {notifications.length === 0 && !loading && (
          <div className="text-sm text-gray-500 mb-4">{t('noNotifications')}</div>
        )}

        {notifications.map(notif => (
          <NotificationCard key={notif.id} notification={notif} outerClassName="mb-4" />
        ))}
      </div>
      {hasMore && (
        <button
          className="block mx-auto mt-8 bg-primary/90 text-white rounded-full px-8 py-3 font-semibold text-lg hover:bg-primary transition"
          onClick={fetchMore}
          disabled={loading}
        >
          {t('loadMore')}
        </button>
      )}
      {error && <div className="text-center text-red-500 my-8">{error}</div>}
    </div>
  );
};

export default Notifications;
